import { BsUtilEmptyMarket, BsUtilEmptySelection } from "./Constants";
import { getMarketEventID, getMarketId, getMarketTypeId, getBetSlipOdds, getSelectionSide, isMarketQA } from "./Helpers";
export function getLegacySelectionData(event, market, selection) {
    const m = Object.assign(Object.assign({}, BsUtilEmptyMarket), market);
    const s = Object.assign(Object.assign({}, BsUtilEmptySelection), selection);
    let qaParameter1 = 0;
    let qaParameter2 = 0;
    if (s.id.indexOf("Q1") !== -1 && s.id.indexOf("Q2") !== -1) {
        qaParameter1 = parseInt(s.id.substring(s.id.indexOf("Q1") + 2, s.id.indexOf("Q2")));
        qaParameter2 = parseInt(s.id.substring(s.id.indexOf("Q2") + 2, s.id.length));
    }
    return {
        masterEventID: parseInt(getMarketEventID(event, m)),
        eventID: parseInt(getMarketId(m)),
        lineID: parseInt(s.metadata.idSBTech),
        odds: parseInt(getBetSlipOdds(s.displayOdds)),
        lineGroupID: s.group,
        lineTypeID: parseInt(s.metadata.type),
        rowTypeID: getSelectionSide(s),
        points: s.points,
        isLive: m.isLive,
        isQA: isMarketQA(m),
        eventTypeId: parseInt(getMarketTypeId(m)),
        leagueId: parseInt(m.leagueId),
        betId: 0,
        preventUpdating: false,
        isFavedTeam: false,
        qaParameter1,
        qaParameter2
    };
}
//# sourceMappingURL=GetLegacySelectionData.js.map